<template>
  <div v-show="false">
    <!-- <v-row>
      <v-container>
      <v-col cols="12">
        <v-btn
      elevation="2"
      @click="handleClickLogin"
      color="green"
      >Google Log in</v-btn>
      </v-col>
      <v-col cols="12">
        <v-card>
          <v-card-text>
            <v-row>
              <v-col cols="12" class="pb-0 pt-0">
                <v-text-field
                  v-model="refreshToken"
                  label="refreshToken"
                  outlined
                ></v-text-field>
              </v-col>
              <v-col cols="12" class="pb-0 pt-0">
                <v-text-field
                  v-model="eventId"
                  label="eventId"
                  outlined
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-btn
                  elevation="2"
                  color="orange"
                  @click="getEvent()"
                  >Get Event</v-btn>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
        <hr>
        <v-card>
          <v-card-text>
            <v-row>
              <v-col cols="12" class="pb-0 pt-0">
                <v-text-field
                  v-model="Summmary"
                  label="Summmary"
                  outlined
                ></v-text-field>
              </v-col>
              <v-col cols="12" class="pb-0 pt-0">
                <v-text-field
                  v-model="Description"
                  label="Description"
                  outlined
                ></v-text-field>
              </v-col>
              <v-col cols="12" class="pb-0 pt-0">
                <v-text-field
                  v-model="Location"
                  label="Location"
                  outlined
                ></v-text-field>
              </v-col>
              <v-col cols="12" class="pb-0 pt-0">
                <v-menu
                  v-model="menu1"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="StartDate"
                      label="StartDate"
                      prepend-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="StartDate"
                    @input="menu1 = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="12" class="pb-0 pt-0">
                <v-menu
                  v-model="menu2"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="EndDate"
                      label="EndDate"
                      prepend-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="EndDate"
                    @input="menu2 = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="12" class="pb-0 pt-0">
                <v-btn
                  elevation="2"
                  color="info"
                  @click="createEvent()"
                  >CREATE Event</v-btn>
              </v-col>
              <v-col cols="12">
                <v-btn
                  elevation="2"
                  color="orange"
                  @click="updateEvent()"
                  >Update Event</v-btn>
              </v-col>
              <v-col cols="12">
                <v-btn
                  elevation="2"
                  color="error"
                  @click="deleteEvent()"
                  >delete Event</v-btn>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
      </v-container>
    </v-row> -->
  </div>
</template>
<script>
import axios from 'axios' // api
import moment from 'moment-timezone'
// import QrcodeVue from 'qrcode.vue'
// import adminLeftMenu from '../Sidebar.vue' // เมนู
export default {
  components: {

  },
  data () {
    return {
      eventId: '',
      calendarId: '66h6jueetal14hcm8vn7an38p8@google.com',
      access_token: '',
      refreshToken: '',
      expireDate: '',
      checkLogin: false,
      Summmary: '',
      Description: '',
      Location: '',
      menu1: false,
      menu2: false,
      StartDate: '',
      EndDate: '',
      session: this.$session.getAll(),
      shopId: this.$session.getAll().data.shopId,
      bookingItem: [],
      bookingData: [],
      flowItem: [],
      empItem: [],
      evenStatus: '',
      attendeesEmail: [],
      bookNo: '',
      statusGoogleCalendarEmp: '',
      webHookUrl: 'https://asia-southeast1-be-linked-a7cdc.cloudfunctions.net/'
      // webHookUrl: 'http://127.0.0.1:5004/be-linked-a7cdc/asia-southeast1/'
    }
  },
  async mounted () {
    // await this.checkTypeEvenEmp()
    // this.setTimeEmp()
  },
  methods: {
    validateEmail (email) {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
      return emailRegex.test(email)
    },
    async UseGoogleCalendar () {
      await this.getShop()
      if (this.access_token === null || this.access_token === '') {
        await this.handleClickLoginByUse()
      }
    },
    async loginGoogleCalendarEmp (item) {
      if (item.empId !== null || item.empId !== '') {
        let empId = item.empId
        await this.handleClickLoginByEmp(empId)
      }
    },
    async handleClickLoginByEmp (empId) {
      this.$gAuth
        .getAuthCode()
        .then((authCode) => {
          // on success
          console.log('authCode', authCode)
          axios
            .post(this.webHookUrl + 'GoogleCalendar-createToken', {code: authCode}, {timeout: 10000})
            // .post('http://localhost:5002/be-linked-a7cdc/asia-southeast1/GoogleCalendar-createToken', {code: authCode})
            .then(async (response) => {
              // this.checkLogin = true
              await this.UpdateRefreshTokenEmp(empId, response.data)
            }).catch((err) => {
              console.log('err', err)
            })
        })
        .catch((error) => {
          console.log('error login', error)
          // on fail do something
        })
    },
    async handleClickLoginByUse () {
      this.$gAuth
        .getAuthCode()
        .then((authCode) => {
          // on success
          axios
            .post(this.webHookUrl + 'GoogleCalendar-createToken', {code: authCode}, {timeout: 10000})
            .then(async (response) => {
              await this.UpdateRefreshToken(response.data)
            }).catch((err) => {
              console.log('err', err)
            })
        })
        .catch((error) => {
          console.log('error login', error)
          // on fail do something
        })
    },
    async checkTypeEvenEmpNoSession (status, bookNo, shopId, DNS_IP) {
      this.shopId = shopId
      this.$DNS_IP = DNS_IP
      this.eventId = ''
      this.calendarId = '66h6jueetal14hcm8vn7an38p8@google.com'
      this.refreshToken = ''
      this.access_token = ''
      this.expireDate = ''
      this.checkLogin = false
      this.Summmary = ''
      this.Description = ''
      this.Location = ''
      this.menu1 = false
      this.menu2 = false
      this.StartDate = ''
      this.EndDate = ''
      this.bookingItem = []
      this.bookingData = []
      this.flowItem = []
      this.empItem = []
      this.evenStatus = ''
      this.attendeesEmail = []
      this.bookNo = ''
      this.statusGoogleCalendarEmp = ''
      this.webHookUrl = 'https://asia-southeast1-be-linked-a7cdc.cloudfunctions.net/'
      await this.checkTypeEvenEmp(status, bookNo)
    },
    async checkTypeEvenEmp (status, bookNo) {
      this.evenStatus = status
      this.bookNo = bookNo
      await this.getShop()
      if (this.access_token === null || this.access_token === '') {
        // await this.handleClickLogin(status, bookNo)
      } else {
        await this.getBooking(this.bookNo)
        await this.getBookingData(this.bookNo)
        await this.getFlow(this.bookingItem[0].flowId)
        if (this.statusGoogleCalendarEmp === 'True') {
          await this.getEmp(this.bookingItem[0].bookingEmpFlow)
          // await this.setTokenByEmp()
        }
        if (this.evenStatus === 'Add') {
          await this.buliDataEmpCreateLog('Add')
          let allItem = await this.buliDataEmp('Add')
          await this.createEvent(allItem)
          if (this.shopId === 'Ub7cbc419244731cdd682354dd0e57cef') {
            this.sentEmailEmp(bookNo)
          }
        } else if (this.evenStatus === 'Edit') {
          let allItem = await this.buliDataEmp('Edit')
          console.log('Edit!!')
          await this.updateEvent(allItem)
        } else if (this.evenStatus === 'Delete') {
          await this.deleteEvent(this.bookNo)
        //   let allItem = await this.buliDataEmp('Delete')
        }
      }
    },
    async buliDataEmp (status) {
      let item = {}
      item.access_token = this.access_token
      item.refreshToken = this.refreshToken
      item.bookNo = this.bookingItem[0].bookNo
      if (this.shopId) {
        item.shopId = this.shopId
      }
      item.Summmary = this.bookingItem[0].flowName + ' - ' + this.bookingData.filter((a) => a.fieldName === 'ชื่อ')[0].fieldValue
      let Description = ''
      if (this.bookingItem[0].masBranchName !== null || this.bookingItem[0].masBranchName !== '') {
        Description += 'สาขา :' + this.bookingItem[0].masBranchName
        Description += '\n'
      }
      for (const a of this.bookingData) {
        Description += a.fieldName + ' : ' + (a.fieldValue || ' ')
        Description += '\n'
      }
      Description += 'ชื่อช่าง :' + this.bookingItem[0].bookingEmpFlowName
      //    แปลงเวลานัดหมาย
      item.Description = Description
      const timezone = 'Asia/Bangkok'
      const dateSelect = moment.tz(`${this.bookingItem[0].dueDateDay} ${this.bookingItem[0].timeDue}`, 'YYYY-MM-DD HH:mm', timezone).format()
      item.StartDate = dateSelect
      item.EndDate = await this.setTimeEmp(dateSelect, this.bookingItem)
      await this.getSysUser()
      console.log('this.attendeesEmail', this.attendeesEmail)
      item.attendees = this.attendeesEmail
      // console.log('this.empItem', this.empItem)
      if (this.statusGoogleCalendarEmp === 'True') {
        if (status === 'Add') {
          try {
            if (this.validateEmail(this.empItem[0].empEmail)) {
              let obj = {'email': this.empItem[0].empEmail}
              item.attendees.push(obj)
            }
          } catch (error) {
            console.log(error)
          }
        } else if (status === 'Edit') {
          try {
            if (this.validateEmail(this.empItem[0].empEmail)) {
              let obj = {'email': this.empItem[0].empEmail}
              item.attendees.push(obj)
            }
          } catch (error) {
            console.log(error)
          }
        }
        if (this.shopId === 'Ub7cbc419244731cdd682354dd0e57cef' || this.shopId === this.shopNameData.englishMunmunCoppyTest) {
          try {
            if (this.empItem[0].refreshTokenGoogleCalendar) {
              let data = await this.getRefreshTotokenEmp(this.empItem[0].refreshTokenGoogleCalendar)
              if (data) {
                console.log('$$$$$$$$$', data)
                item.access_token = data
                item.refreshToken = this.empItem[0].refreshTokenGoogleCalendar
                if (this.session.data.contactEmail) {
                  let obj = {'email': this.session.data.contactEmail}
                  item.attendees.push(obj)
                }
              }
            }
          } catch (error) {
            item.access_token = this.access_token
          }
        }
      }
      console.log(this.flowItem)
      if (this.flowItem[0].GoogleCalendarMeet === 'True') {
        item.requestId = this.bookingItem[0].bookNo
        if (this.bookingItem[0].bookingDataCustomerEmail !== null && this.bookingItem[0].bookingDataCustomerEmail !== '') {
          let obj = {'email': this.bookingItem[0].bookingDataCustomerEmail}
          item.attendees.push(obj)
        }
      }
      return item
    },
    async buliDataEmpCreateLog (status) {
      let item = {}
      item.access_token = this.access_token
      item.refreshToken = this.refreshToken
      item.bookNo = this.bookingItem[0].bookNo
      item.Summmary = this.bookingItem[0].flowName + ' - ' + this.bookingData.filter((a) => a.fieldName === 'ชื่อ')[0].fieldValue
      let Description = ''
      if (this.bookingItem[0].masBranchName !== null || this.bookingItem[0].masBranchName !== '') {
        Description += 'สาขา :' + this.bookingItem[0].masBranchName
        Description += '\n'
      }
      this.bookingData.forEach((a) => {
        Description += a.fieldName + ' : ' + (a.fieldValue || ' ')
        Description += '\n'
      })
      if (this.shopId) {
        item.shopId = this.shopId
      }
      if (this.shopId === 'Ub7cbc419244731cdd682354dd0e57cef' || this.shopId === this.shopNameData.englishMunmunCoppyTest) {
        Description += 'ชื่อครู :' + this.bookingItem[0].bookingEmpFlowName
      } else if (this.shopId === 'U0774cc75554f5f80bf2fb88888c2eec3') {
        Description += 'ชื่อ Mentor :' + this.bookingItem[0].bookingEmpFlowName
      } else {
        Description += 'ชื่อช่าง :' + this.bookingItem[0].bookingEmpFlowName
      }
      if (this.shopId === 'U93c42b54e45cfe584473c03e35746955' || this.shopId === 'Ub7cbc419244731cdd682354dd0e57cef' || this.shopId === this.shopNameData.englishMunmunCoppyTest) {
        let setUpTimes = await this.setUpTime(this.bookingItem[0].dueDateDay, this.bookingItem[0].timeDue, 60)
        item.StartDate = setUpTimes.startDate
        item.EndDate = setUpTimes.endDate
      } else {
        //    แปลงเวลานัดหมาย
        const timezone = 'Asia/Bangkok'
        const dateSelectNew = moment.tz(`${this.bookingItem[0].dueDateDay} ${this.bookingItem[0].timeDue}`, 'YYYY-MM-DD HH:mm', timezone).format()
        // const dateSelect = moment(`${this.bookingItem[0].dueDateDay} ${this.bookingItem[0].timeDue}`).format('YYYY-MM-DD HH:mm')
        item.StartDate = dateSelectNew
        item.EndDate = await this.setTimeEmp(dateSelectNew, this.bookingItem)
        if (item.StartDate >= item.EndDate) {
          // send noti item.StartDate  item.EndDate
          // let test = dateSelect.add(60, 'minutes')
          // item.EndDate = moment.tz(test, 'YYYY-MM-DD HH:mm', timezone).format()
          let dtInput = moment(`${this.bookingItem[0].dueDateDay} ${this.bookingItem[0].timeDue}`).format('YYYY-MM-DD HH:mm')
          const dt = moment.tz(dtInput, 'YYYY-MM-DD HH:mm', timezone)
          const EndDateTime = dt.clone().add(60, 'minutes').format('YYYY-MM-DD HH:mm')
          item.EndDate = moment.tz(`${EndDateTime}`, 'YYYY-MM-DD HH:mm', timezone).format()
        }
      }
      if (this.shopId === 'U93c42b54e45cfe584473c03e35746955' || this.shopId === 'Ub7cbc419244731cdd682354dd0e57cef' || this.shopId === this.shopNameData.englishMunmunCoppyTest) {
        try {
          const startDate = moment(item.StartDate).utcOffset('+07:00').locale('en')
          const endDate = moment(item.EndDate).utcOffset('+07:00').locale('en')

          // แปลงวันที่เป็นรูปแบบที่ต้องการ
          const formattedStart = startDate.format('DD MMM YYYY HH:mm')
          const formattedEnd = endDate.format('HH:mm')
          Description += '\n'
          Description += `${formattedStart} - ${formattedEnd} เวลาประเทศไทย (Thailand Time)`
        } catch (error) {
          console.log('error------->>>>>>>>', error)
        }
      }
      item.Description = Description
      await this.getSysUser()
      item.attendees = this.attendeesEmail
      if (this.statusGoogleCalendarEmp === 'True') {
        if (status === 'Add') {
          try {
            if (this.validateEmail(this.empItem[0].empEmail)) {
              let obj = {'email': this.empItem[0].empEmail}
              item.attendees.push(obj)
            }
          } catch (error) {
            console.log(error)
          }
        } else if (status === 'Edit') {
          try {
            if (this.validateEmail(this.empItem[0].empEmail)) {
              let obj = {'email': this.empItem[0].empEmail}
              item.attendees.push(obj)
            }
          } catch (error) {
            console.log(error)
          }
        }
        if (this.shopId === 'Ub7cbc419244731cdd682354dd0e57cef' || this.shopId === 'U0774cc75554f5f80bf2fb88888c2eec3' || this.shopId === this.shopNameData.englishMunmunCoppyTest) {
          try {
            if (this.empItem[0].refreshTokenGoogleCalendar) {
              item.refreshToken = this.empItem[0].refreshTokenGoogleCalendar
              if (this.contactEmail) {
                let obj = {'email': this.contactEmail}
                item.attendees.push(obj)
              }
            }
          } catch (error) {
            item.access_token = ''
          }
        }
      }
      if (this.flowItem[0].GoogleCalendarMeet === 'True') {
        item.requestId = this.bookingItem[0].bookNo
        if (this.bookingItem[0].bookingDataCustomerEmail !== null && this.bookingItem[0].bookingDataCustomerEmail !== '') {
          let obj = {'email': this.bookingItem[0].bookingDataCustomerEmail}
          item.attendees.push(obj)
        }
      }
      try {
        this.addLogWait(item)
      } catch (error) {
        console.log('error', error)
      }
    },
    async checkTypeEvenNoSession (status, bookNo, shopId, DNS_IP) {
      this.shopId = shopId
      this.$DNS_IP = DNS_IP
      this.eventId = ''
      this.calendarId = '66h6jueetal14hcm8vn7an38p8@google.com'
      this.refreshToken = ''
      this.access_token = ''
      this.expireDate = ''
      this.checkLogin = false
      this.Summmary = ''
      this.Description = ''
      this.Location = ''
      this.menu1 = false
      this.menu2 = false
      this.StartDate = ''
      this.EndDate = ''
      this.bookingItem = []
      this.bookingData = []
      this.flowItem = []
      this.empItem = []
      this.evenStatus = ''
      this.attendeesEmail = []
      this.bookNo = ''
      this.statusGoogleCalendarEmp = ''
      this.webHookUrl = 'https://asia-southeast1-be-linked-a7cdc.cloudfunctions.net/'
      console.log('2this.$DNS_IP', this.$DNS_IP)
      console.log('2------', this.$DNS_IP + '/sys_shop/get?shopId=' + this.shopId)
      console.log('status!!', status)
      await this.checkTypeEven(status, bookNo)
    },
    async checkTypeEven (status, bookNo) {
      console.log('status!!', status)
      this.evenStatus = status
      //   this.evenStatus = 'Add'
      this.bookNo = bookNo
      //   this.bookNo = 'BK143157651684727414315'
      console.log('this.$DNS_IP', this.$DNS_IP)
      console.log('this.shopId', this.shopId)
      await this.getShop()
      if (this.access_token === null || this.access_token === '') {
        // await this.handleClickLogin(status, bookNo)
      } else {
        await this.getBooking(this.bookNo)
        await this.getBookingData(this.bookNo)
        await this.getFlow(this.bookingItem[0].flowId)
        // if (this.statusGoogleCalendarEmp === 'True') {
        //   await this.getEmp(this.bookingItem[0].bookingEmpFlow)
        // }
        if (this.evenStatus === 'Add') {
          await this.buliDataCreateLog('Add')
          let allItem = await this.buliData('Add')
          await this.createEvent(allItem)
        } else if (this.evenStatus === 'Edit') {
          let allItem = await this.buliData('Edit')
          console.log('Edit!!')
          await this.updateEvent(allItem)
        } else if (this.evenStatus === 'Delete') {
          await this.deleteEvent(this.bookNo)
        //   let allItem = await this.buliDataEmp('Delete')
        }
      }
    },
    async buliData (status) {
      let item = {}
      item.access_token = this.access_token
      item.refreshToken = this.refreshToken
      item.bookNo = this.bookingItem[0].bookNo
      if (this.shopId) {
        item.shopId = this.shopId
      }
      item.Summmary = this.bookingItem[0].flowName + ' - ' + this.bookingData.filter((a) => a.fieldName === 'ชื่อ')[0].fieldValue
      let Description = ''
      if (this.bookingItem[0].masBranchName !== null || this.bookingItem[0].masBranchName !== '') {
        Description += 'สาขา :' + this.bookingItem[0].masBranchName
        Description += '\n'
      }
      this.bookingData.forEach((a) => {
        Description += a.fieldName + ' : ' + (a.fieldValue || ' ')
        Description += '\n'
      })
      //    แปลงเวลานัดหมาย
      item.Description = Description
      const timezone = 'Asia/Bangkok'
      const dateSelect = moment.tz(`${this.bookingItem[0].dueDateDay} ${this.bookingItem[0].timeDue}`, 'YYYY-MM-DD HH:mm', timezone).format()
      item.StartDate = dateSelect
      item.EndDate = await this.setTimeFlow(dateSelect, this.bookingItem[0].flowId)
      await this.getSysUser()
      console.log('this.attendeesEmail', this.attendeesEmail)
      item.attendees = this.attendeesEmail
      if (this.flowItem[0].GoogleCalendarMeet === 'True') {
        item.requestId = this.bookingItem[0].bookNo
        if (this.bookingItem[0].bookingDataCustomerEmail !== null && this.bookingItem[0].bookingDataCustomerEmail !== '') {
          let obj = {'email': this.bookingItem[0].bookingDataCustomerEmail}
          item.attendees.push(obj)
        }
      }
      return item
    },
    async buliDataCreateLog (status) {
      let item = {}
      item.access_token = this.access_token
      item.refreshToken = this.refreshToken
      item.bookNo = this.bookingItem[0].bookNo
      item.Summmary = this.bookingItem[0].flowName + ' - ' + this.bookingData.filter((a) => a.fieldName === 'ชื่อ')[0].fieldValue
      let Description = ''
      if (this.bookingItem[0].masBranchName !== null || this.bookingItem[0].masBranchName !== '') {
        Description += 'สาขา :' + this.bookingItem[0].masBranchName
        Description += '\n'
      }
      this.bookingData.forEach((a) => {
        Description += a.fieldName + ' : ' + (a.fieldValue || ' ')
        Description += '\n'
      })
      if (this.shopId) {
        item.shopId = this.shopId
      }
      //    แปลงเวลานัดหมาย
      item.Description = Description
      const timezone = 'Asia/Bangkok'
      const dateSelect = moment.tz(`${this.bookingItem[0].dueDateDay} ${this.bookingItem[0].timeDue}`, 'YYYY-MM-DD HH:mm', timezone).format()
      item.StartDate = dateSelect
      item.EndDate = await this.setTimeFlow(dateSelect, this.bookingItem[0].flowId)
      await this.getSysUser()
      console.log('this.attendeesEmail', this.attendeesEmail)
      item.attendees = this.attendeesEmail
      if (this.flowItem[0].GoogleCalendarMeet === 'True') {
        item.requestId = this.bookingItem[0].bookNo
        if (this.bookingItem[0].bookingDataCustomerEmail !== null && this.bookingItem[0].bookingDataCustomerEmail !== '') {
          let obj = {'email': this.bookingItem[0].bookingDataCustomerEmail}
          item.attendees.push(obj)
        }
      }
      try {
        this.addLogWait(item)
      } catch (error) {
        console.log('error', error)
      }
    },
    async sentEmailEmp (bookNo) {
      let dt = {
        'bookNo': bookNo
      }
      await axios.post(this.$DNS_IP + '/email_booking/confirmEnglistMunMun', dt)
        .then(response => {})
        .catch(error => { console.log(error) })
    },
    async getBooking () {
      await axios.get(this.$DNS_IP + '/booking_view/get?bookNo=' + this.bookNo).then(response => {
        let rs = response.data
        if (rs.length > 0) {
          this.bookingItem = rs
        }
      })
    },
    async getBookingData () {
      await axios.get(this.$DNS_IP + '/BookingData/get?bookNo=' + this.bookNo).then(response => {
        let rs = response.data
        if (rs.length > 0) {
          this.bookingData = rs
        }
      })
    },
    async getFlow (flowId) {
      await axios.get(this.$DNS_IP + '/flow/get?flowId=' + flowId).then(response => {
        let rs = response.data
        if (rs.length > 0) {
          this.flowItem = rs
          console.log('FLOW-----------!!!!!', this.flowItem)
        }
      })
    },
    async getEmp (empId) {
      await axios.get(this.$DNS_IP + '/empSelect/get?empId=' + empId).then(response => {
        let rs = response.data
        if (rs.length > 0) {
          this.empItem = rs
        }
      })
    },
    async setTimeEmp (dateSelect, bookingData) {
      // this.flowItem
      let date = moment(dateSelect).format('YYYY-MM-DD')
      let time = moment(dateSelect).format('HH:mm')
      // console.log('time', time)
      let timeSlot = bookingData[0].timeSlotCustomer || 1
      // console.log('timeSlot', timeSlot)
      let countTime = 60
      try {
        let setTime = await this.getTimeEmp(date, bookingData[0].bookingEmpFlow)
        // console.log(setTime)
        if (setTime.length === 0 || setTime.length === 1) {
          countTime = 60
        } else {
          let firtIndex = setTime.findIndex((item) => item.value === time)
          // console.log('firtIndex', firtIndex)
          let filterTime = setTime.filter((item, index) => index >= firtIndex && index <= ((timeSlot + firtIndex)))
          // console.log('filterTime', filterTime)
          if (timeSlot !== filterTime.length) {
            let previousTime = moment(setTime[0].value, 'HH:mm')
            let currentTime = moment(setTime[1].value, 'HH:mm')
            const diffMinutes = currentTime.diff(previousTime, 'minutes')
            countTime = (diffMinutes * timeSlot) === 0 ? 60 : (diffMinutes * timeSlot)
            // console.log('diffMinutes', diffMinutes)
          } else {
            let previousTime = moment(filterTime[0].value, 'HH:mm')
            let currentTime = moment(filterTime[filterTime.length - 1].value, 'HH:mm')
            // console.log('previousTime', previousTime)
            // console.log('currentTime', currentTime)
            const diffMinutes = currentTime.diff(previousTime, 'minutes')
            countTime = diffMinutes === 0 ? 60 : diffMinutes
            // console.log('diffMinutesElse', diffMinutes)
          }
        }
        // console.log('countTime', countTime)
      } catch (error) {
        console.error('Error fetching flow data:', error)
        countTime = 60
      }
      const timezone = 'Asia/Bangkok'
      let dtInput = moment(dateSelect).format('YYYY-MM-DD HH:mm')
      const dt = moment.tz(dtInput, 'YYYY-MM-DD HH:mm', timezone)
      const EndDateTime = dt.clone().add(countTime, 'minutes').format('YYYY-MM-DD HH:mm')
      let dataReturn = moment.tz(`${EndDateTime}`, 'YYYY-MM-DD HH:mm', timezone).format()
      // console.log('dataReturn', dataReturn)
      return dataReturn
    },
    async getTimeEmp (dateSelect, empId) {
      try {
        const response = await axios.get(this.$DNS_IP + '/empSelect/get?empId=' + empId)
        const rs = response.data
        console.log('----------RS', rs)
        if (rs.length > 0) {
          let setTime = []
          if (rs[0].setTimebyday === 'True') {
            let timeData = JSON.parse(rs[0].setTime)
            let timeJson = timeData.filter((items) => items.value === new Date(dateSelect).getDay()) || []
            // console.log('timeJson', timeJson)
            setTime = timeJson[0].setTime || []
          } else {
            setTime = JSON.parse(rs[0].setTime) || []
          }
          return setTime
        } else {
          return []
        }
      } catch (error) {
        console.error('Error fetching flow data2:', error)
        return []
      }
    },
    async setTimeFlow (dateSelect, flowId) {
      const timezone = 'Asia/Bangkok'
      let dtInput = moment(dateSelect).format('YYYY-MM-DD HH:mm')
      const dt = moment.tz(dtInput, 'YYYY-MM-DD HH:mm', timezone)
      // console.log('dt', dt)
      let countTime = 60
      try {
        const response = await axios.get(this.$DNS_IP + '/flow/get?flowId=' + flowId)
        const rs = response.data
        if (rs.length > 0) {
          console.log('FLOW-------!!!!!', rs)
          countTime = rs[0].OnsiteEndTime === 0 ? 60 : rs[0].OnsiteEndTime
          const EndDateTime = dt.clone().add(countTime, 'minutes').format('YYYY-MM-DD HH:mm')
          let dataReturn = moment.tz(`${EndDateTime}`, 'YYYY-MM-DD HH:mm', timezone).format()
          // คืนค่า countTime หรือ EndDateTime ตามที่ต้องการ
          return dataReturn // หรือ return EndDateTime ตามที่คุณต้องการ
        }
      } catch (error) {
        console.error('Error fetching flow data:', error)
        const EndDateTime = dt.clone().add(countTime, 'minutes').format('YYYY-MM-DD HH:mm')
        let dataReturn = moment.tz(`${EndDateTime}`, 'YYYY-MM-DD HH:mm', timezone).format()
        return dataReturn
      }
    },
    // async checkExpireDate (expireDate) {
    //   // const timestamp = 1684397395837
    //   // const expirationDate = moment.utc(timestamp)
    //   const currentDate = moment()
    //   // console.log('currentDate', currentDate)
    //   if (currentDate.isAfter(expireDate)) {
    //     console.log('รหัสหมดอายุแล้ว1')
    //     await this.handleClickLogin()
    //   } else {
    //     console.log('รหัสยังไม่หมดอายุ1')
    //   }
    // // },
    // ConvertToDateTime (expirydate) {
    //   const timestamp = expirydate
    //   const dateTime = moment(timestamp).format('YYYY-MM-DD HH:mm:ss')
    //   console.log(dateTime)
    //   return dateTime
    // },
    async UpdateRefreshTokenEmp (empId, res) {
      console.log('res', res)
      const refreshToken = res.refresh_token
      const item = {
        refreshTokenGoogleCalendar: refreshToken
      }
      await axios
        .post(this.$DNS_IP + '/empSelect/edit/' + parseInt(empId), item)
        .then(async response => {
          console.log('response', response)
        })
        .catch((err) => { console.log('error', err) })
    },
    async UpdateRefreshToken (res) {
      console.log('res', res)
      const refreshToken = res.refresh_token
      const item = {
        refreshTokenGoogleCalendar: refreshToken
      }
      await axios
        .post(this.$DNS_IP + '/sys_shop/edit/' + this.shopId, item)
        .then(async response => {
          console.log('response', response)
        })
        .catch((err) => { console.log('error', err) })
    },
    async handleClickLogin (status, bookNo) {
      this.$gAuth
        .getAuthCode()
        .then((authCode) => {
          // on success
          console.log('authCode', authCode)
          axios
            .post(this.webHookUrl + 'GoogleCalendar-createToken', {code: authCode}, {timeout: 10000})
            // .post('http://localhost:5002/be-linked-a7cdc/asia-southeast1/GoogleCalendar-createToken', {code: authCode})
            .then(async (response) => {
              // this.checkLogin = true
              console.log('token', response.data)
              await this.UpdateRefreshToken(response.data)
              await this.checkTypeEvenEmp(status, bookNo)
            }).catch((err) => {
              console.log('err', err)
            })
        })
        .catch((error) => {
          console.log('error login', error)
          // on fail do something
        })
    },
    async UpdateEventId_Booking (bookNo, googleCalendarEventId) {
      console.log('response.data.id', googleCalendarEventId)
      const dataitem = {
        'googleCalendarEventId': googleCalendarEventId
      }
      try {
        const dataReturn = await axios.post(this.$DNS_IP + '/Booking/edit/' + bookNo, dataitem)
        if (dataReturn.status) {
          return true
        } else {
          return false
        }
      } catch (err) {
        return false
      }
      // await axios
      //   .post(this.$DNS_IP + '/Booking/edit/' + bookNo, dataitem)
      //   .then(async response => {
      //     console.log('response!@!@!@!@', response)
      //   })
      //   .catch((err) => { console.log('error', err) })
    },
    async createEvent (item, bookNo) {
      try {
        await axios
          .post(this.$DNS_IP + '/GoogleCalendar/create', item)
          .then(async response => { console.log(response) })
      } catch (error) {
        console.log('error', error)
      }
    },
    async sentLineNotifyError (message) {
      const dt = {
        'message': message
      }
      const sentError = await axios.post(this.$DNS_IP + '/GoogleCalendarSentNotiError', dt)
      console.log('sentError', sentError)
    },
    getEvent () {
      let dt = {
        access_token: this.access_token,
        eventId: this.eventId
      }
      axios
        .post(this.webHookUrl + 'GoogleCalendar-getEvent', dt, {timeout: 10000})
        .then(async (response) => {
          console.log('getEvent', response.data)
          if (response.data.status === 200) {
            this.Summmary = response.data.data.summary
            this.Description = response.data.data.description
            this.Location = response.data.data.location
            this.StartDate = this.momenDate_1(response.data.data.start.dateTime)
            this.EndDate = this.momenDate_1(response.data.data.end.dateTime)
          } else {
            this.Summmary = ''
            this.Description = ''
            this.Location = ''
            this.StartDate = ''
            this.EndDate = ''
          }
        })
    },
    async getEventCheck () {
      let itemGet = {
        access_token: this.access_token,
        eventId: this.bookingItem[0].googleCalendarEventId
      }
      let rsData = []
      await axios
        .post(this.webHookUrl + 'GoogleCalendar-getEvent', itemGet, {timeout: 10000})
        .then(async (response) => {
          console.log('getEvent', response.data)
          if (response.data.status === 200) {
            let rs = response.data.data
            if (rs.attendees) {
              let empEmail = rs.attendees.filter((a) => a.email !== rs.creator.email)
              rsData = empEmail
            } else {
              rsData = []
            }
          } else {
            rsData = []
          }
        })
      return rsData
    },
    async updateEvent (item) {
      let itemUpdate = item
      itemUpdate.eventId = this.bookingItem[0].googleCalendarEventId
      // console.log('this.bookingItem[0].googleCalendarEventId', itemUpdate)
      if (this.bookingItem[0].googleCalendarEventId !== null) {
        // try {
        //   await axios
        //     .post(this.webHookUrl + 'GoogleCalendar-updateEvent', itemUpdate, {timeout: 10000})
        //     .then(async (response) => {
        //       console.log('updateEvent11', response.data)
        //     }).catch((err) => {
        //       console.log('error', err)
        //     })
        // } catch (error) {
        //   let message = 'Update GoogleCalendar Api Error  bookNo : ' + this.bookingItem[0].bookNo + ' shopId :' + this.shopId + ' error : ' + error
        //   this.sentLineNotifyError(message)
        //   console.log('error', error)
        // }
        try {
          await axios
            .post(this.$DNS_IP + '/GoogleCalendar/update', itemUpdate)
            .then(async response => { console.log(response) })
        } catch (error) {
          console.log('error', error)
        }
      }
      // else {
      //   let message = 'Update GoogleCalendar Api Error  bookNo : ' + this.bookingItem[0].bookNo + ' shopId :' + this.shopId + ' ไม่มี googleCalendarEventId'
      //   this.sentLineNotifyError(message)
      // }
    },
    async deleteEvent (bookNo) {
      let dt = {
        refreshToken: this.refreshToken,
        access_token: this.access_token,
        eventId: this.bookingItem[0].googleCalendarEventId,
        bookNo: this.bookNo
      }
      if (this.bookingItem[0].googleCalendarEventId !== null) {
        try {
          await axios
            .post(this.$DNS_IP + '/GoogleCalendar/delete', dt)
            .then(async response => { console.log(response) })
        } catch (error) {
          console.log('error', error)
        }
      }
      // try {
      //   const response = await axios.post(this.webHookUrl + 'GoogleCalendar-deleteEvent', dt, {timeout: 20000})
      //   console.log('responseDELETE-----------', response)
      //   if (parseInt(response.data.status) > 300) {
      //     let message = 'Delete GoogleCalendar Api Error bookNo : ' + this.bookingItem[0].bookNo + ' shopId :' + this.shopId + ' error : ' + response.data.status
      //     this.sentLineNotifyError(message)
      //   }
      // } catch (error) {
      //   let message = 'Delete GoogleCalendar Api Error bookNo : ' + this.bookingItem[0].bookNo + ' shopId :' + this.shopId + ' error : ' + error
      //   this.sentLineNotifyError(message)
      // }
    },
    async getShop () {
      await axios.get(this.$DNS_IP + '/sys_shop/get?shopId=' + this.shopId).then(async (response) => {
        let rs = response.data
        if (rs.length > 0) {
          // await this.getSysUser()
          if (this.shopId === 'Ub7cbc419244731cdd682354dd0e57cef' || this.shopId === this.shopNameData.englishMunmunCoppyTest) {
            console.log('_____IF')
            if (rs[0].refreshTokenGoogleCalendar) {
              await this.getRefreshTotoken(rs[0].refreshTokenGoogleCalendar)
            } else {
              this.refreshToken = ''
              this.access_token = ''
            }
          } else {
            console.log('_____ELSE')
            await this.getAccess_token()
          }
          // saichongot123@gmail.com 1//0g96maaiJcjKnCgYIARAAGBASNwF-L9IrvFA4GuAGtvfLf5ZfmSDxoXxBeym4BpxaJjVoc5SrB176u4FsYYoCCWa7rrwdAh-CZkA
          // this.refreshToken = '1//0gYwyLYeD179cCgYIARAAGBASNwF-L9Ir4eWR6-pPbjgYzJYPqm74y0-JiXqw5EmCbKduRf5VF0c1BIgD37qsWdtqt7bENC5uBss'
          this.statusGoogleCalendarEmp = rs[0].statusGoogleCalendarEmp
          //   this.expireDate = rs[0].expireDateGoogleCalendar
          // console.log('this.refreshToken', this.refreshToken)
        }
      })
    },
    async getAccess_token () {
      await axios.get(this.$DNS_IP + '/GoogleCalendarRefreshToken/get').then(response => {
        let rs = response.data
        if (rs.length > 0) {
          console.log('GoogleCalendarRefreshToken', rs)
          this.refreshToken = rs[0].refreshToken
          this.access_token = rs[0].access_token
        }
      })
    },
    async getRefreshTotokenEmp (refreshToken) {
      let dt = {
        refreshToken: refreshToken
      }
      let token = null
      await axios
        .post(this.webHookUrl + 'GoogleCalendar-GetToken', dt)
        .then(async (response) => {
          console.log(response)
          if (response.data.access_token) {
            token = response.data.access_token
          }
        })
        .catch((error) => {
          console.log(error)
        })
      console.log('token', token)
      return token
    },
    async getRefreshTotoken (refreshToken) {
      let dt = {
        refreshToken: refreshToken
      }
      await axios
        .post(this.webHookUrl + 'GoogleCalendar-GetToken', dt)
        .then(async (response) => {
          console.log(response)
          if (response.data.access_token) {
            this.access_token = response.data.access_token
          }
        })
        .catch((error) => {
          console.log(error)
        })
    },
    async getSysUser () {
      await axios.get(this.$DNS_IP + '/system_user/get?shopId=' + this.shopId + '&USER_ROLE=admin').then(response => {
        let rs = response.data
        if (rs.length > 0) {
          console.log('system_user', rs)
          for (const item of rs) {
            try {
              if (this.validateEmail(item.userName)) {
                let obj = {'email': item.userName}
                this.attendeesEmail.push(obj)
              }
            } catch (error) {
              console.log(error)
            }
          }
          // rs.forEach((item) => {
          //   try {
          //     if (this.validateEmail(item.userName)) {
          //       let obj = {'email': item.userName}
          //       this.attendeesEmail.push(obj)
          //     }
          //   } catch (error) {
          //     console.log(error)
          //   }
          // })
        }
      })
    },
    async addLogWait (item) {
      console.log('addLogWait------', item)
      await axios.post(this.$DNS_IP + '/GoogleCalendar/addWait', item)
        .then(response => {})
        .catch(error => { console.log(error) })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Core/GoogleCalendarCmp.vue